import { AfterViewChecked, ChangeDetectionStrategy, Component, Inject, OnInit, ViewChild } from '@angular/core';
import {
    MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
    MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { ButtonComponent } from '@components/button/component/button.component';
import { LANG_DICTIONARY_TOKEN } from '@constants/diConstant';
import { IMainLang } from '@interfaces/languages/main-lang';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent implements OnInit, AfterViewChecked {
    /** Ссылка на кнопку нет */
    @ViewChild('buttonNo') private _buttonNoRef: ButtonComponent;

    /** Флаг установки фокуса на кнопку */
    private initFocus: boolean = false;

    constructor(
        @Inject(LANG_DICTIONARY_TOKEN) public readonly dictionary: IMainLang = null,
        public dialogRef: MatDialogRef<ConfirmDialogComponent, boolean>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            title: string;
            message: string;
        },
    ) {}

    ngOnInit(): void {}

    public ngAfterViewChecked(): void {
        if (!this.initFocus) {
            this._buttonNoRef?.focus();
        }
        this.initFocus = true;
    }
}
